import ToolTipMessages from "./ToolTipMessages";

export default ToolTipMessages;